import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger, Lenis, gsap} from "../LibrariesImport";

export default class SmoothScroll {
	static init() {
		const root = document.documentElement;

		if (ScrollTrigger.isTouch === 1) {
			root.classList.add('touchevents');
		} else {
			root.classList.add('no-touchevents');
			// Initialize a new Lenis instance for smooth scrolling
			GlobalVariables.lenis = new Lenis({
				autoRaf: false,
				lerp: 0.1,
				wheelMultiplier: 1
			});

			// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
			GlobalVariables.lenis.on('scroll', ScrollTrigger.update);

			// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
			// This ensures Lenis's smooth scroll animation updates on each GSAP tick
			gsap.ticker.add((time) => {
				GlobalVariables.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
			});

			// Disable lag smoothing in GSAP to prevent any delay in scroll animations
			gsap.ticker.lagSmoothing(0);

			window.addEventListener('load', () => {
				ScrollTrigger.refresh();
			});

			window.addEventListener('pageshow', (e) => {
				if (e.persisted) ScrollTrigger.refresh();
			});

		}
	}
}


